import { IEncryptionService } from 'vscode/vscode/vs/platform/encryption/common/encryptionService.service';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { ISecretStorageService } from 'vscode/vscode/vs/platform/secrets/common/secrets.service';
import { EncryptionService } from './vscode/src/vs/workbench/services/encryption/browser/encryptionService.js';
import { BrowserSecretStorageService } from './vscode/src/vs/workbench/services/secrets/browser/secretStorageService.js';

function getServiceOverride() {
    return {
        [( ISecretStorageService.toString())]: new SyncDescriptor(BrowserSecretStorageService, [], true),
        [( IEncryptionService.toString())]: new SyncDescriptor(EncryptionService, [], true)
    };
}

export { getServiceOverride as default };
